/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Name_Too_LongInputs */

const en_us2_group_name_too_long = /** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That name is too long.`)
};

const pt_br2_group_name_too_long = /** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome longo demais.`)
};

const pt_pt2_group_name_too_long = /** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome longo demais.`)
};

/** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */
const es_419_group_name_too_long = en_us2_group_name_too_long;

/** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */
const fr_fr2_group_name_too_long = en_us2_group_name_too_long;

/** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */
const de_de2_group_name_too_long = en_us2_group_name_too_long;

/** @type {(inputs: Group_Name_Too_LongInputs) => LocalizedString} */
const it_it2_group_name_too_long = en_us2_group_name_too_long;

/**
* | output |
* | --- |
* | "That name is too long." |
*
* @param {Group_Name_Too_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_name_too_long = /** @type {((inputs?: Group_Name_Too_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Name_Too_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_name_too_long(inputs)
	if (locale === "es-419") return es_419_group_name_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_group_name_too_long(inputs)
	if (locale === "fr-FR") return fr_fr2_group_name_too_long(inputs)
	if (locale === "de-DE") return de_de2_group_name_too_long(inputs)
	if (locale === "it-IT") return it_it2_group_name_too_long(inputs)
	return en_us2_group_name_too_long(inputs)
});
export { group_name_too_long as "group.name_too_long" }